/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 7);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  // extracted by mini-css-extract-plugin
  module.exports = {
    "c-tab": "index__c-tab___2ToGc",
    "is-rtl": "index__is-rtl___3dY0B",
    "c-tab__list": "index__c-tab__list___3SyZH",
    "c-tab__list__item": "index__c-tab__list__item___PLi-k",
    "c-tab__panel": "index__c-tab__panel___B3W-G",
    "c-tab--block": "index__c-tab--block___15Cat",
    "is-last": "index__is-last___27x2Q",
    "is-focused": "index__is-focused___3Drbt",
    "is-hovered": "index__is-hovered___HvGTc",
    "is-active": "index__is-active___36Mvu",
    "is-selected": "index__is-selected___2upPm",
    "is-disabled": "index__is-disabled___QiKeO",
    "is-hidden": "index__is-hidden___M8iKI"
  };
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 3 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-theming");
  /***/
},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("styled-components");
  /***/
},
/* 5 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-selection");
  /***/
},
/* 6 */

/***/
function (module, exports) {
  module.exports = require("classnames");
  /***/
},
/* 7 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "react"


  var external_react_ = __webpack_require__(2);

  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "prop-types"


  var external_prop_types_ = __webpack_require__(0);

  var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_); // EXTERNAL MODULE: external "@zendeskgarden/react-selection"


  var react_selection_ = __webpack_require__(5); // CONCATENATED MODULE: ./src/containers/TabsContainer.js


  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var TabsContainer_TabsContainer = /*#__PURE__*/function (_ControlledComponent) {
    _inherits(TabsContainer, _ControlledComponent);

    function TabsContainer() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, TabsContainer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TabsContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "onTabSelected", function (selectedKey) {
        var onChange = _this.props.onChange;
        onChange && onChange(selectedKey);
      });

      _defineProperty(_assertThisInitialized(_this), "getTabListProps", function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$role = _ref.role,
            role = _ref$role === void 0 ? 'tablist' : _ref$role,
            other = _objectWithoutProperties(_ref, ["role"]);

        return _objectSpread({
          role: role
        }, other);
      });

      _defineProperty(_assertThisInitialized(_this), "getTabProps", function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$role = _ref2.role,
            role = _ref2$role === void 0 ? 'tab' : _ref2$role,
            key = _ref2.key,
            other = _objectWithoutProperties(_ref2, ["role", "key"]);

        if (typeof key === 'undefined' || key === null) {
          throw new Error('"key" must be defined within getTabProps regardless of being used within a .map()');
        }

        return _objectSpread({
          key: key,
          role: role
        }, other);
      });

      _defineProperty(_assertThisInitialized(_this), "getTabPanelProps", function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$role = _ref3.role,
            role = _ref3$role === void 0 ? 'tabpanel' : _ref3$role,
            key = _ref3.key,
            other = _objectWithoutProperties(_ref3, ["role", "key"]);

        if (typeof key === 'undefined' || key === null) {
          throw new Error('"key" must be defined within getTabPanelProps regardless of being used within a .map()');
        }

        var _this$getControlledSt = _this.getControlledState(),
            selectedKey = _this$getControlledSt.selectedKey;

        var isHidden = key !== selectedKey;
        return _objectSpread({
          key: key,
          role: role,
          'aria-hidden': isHidden
        }, other);
      });

      _this.state = {
        focusedKey: undefined,
        selectedKey: undefined,
        id: react_selection_["IdManager"].generateId('garden-tabs-container')
      };
      return _this;
    }

    _createClass(TabsContainer, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            children = _this$props.children,
            _this$props$render = _this$props.render,
            render = _this$props$render === void 0 ? children : _this$props$render,
            vertical = _this$props.vertical;

        var _this$getControlledSt2 = this.getControlledState(),
            focusedKey = _this$getControlledSt2.focusedKey,
            selectedKey = _this$getControlledSt2.selectedKey,
            id = _this$getControlledSt2.id;

        return external_react_default.a.createElement(react_selection_["SelectionContainer"], {
          id: id,
          direction: vertical ? 'vertical' : 'horizontal',
          focusedKey: focusedKey,
          selectedKey: selectedKey,
          onStateChange: function onStateChange(newState) {
            /**
             * A new tab has been selected
             */
            if (Object.prototype.hasOwnProperty.call(newState, 'selectedKey')) {
              _this2.onTabSelected(newState.selectedKey);
            }

            _this2.setControlledState(newState);
          }
        }, function (_ref4) {
          var getContainerProps = _ref4.getContainerProps,
              getItemProps = _ref4.getItemProps;
          return render({
            getTabListProps: function getTabListProps(props) {
              return getContainerProps(_this2.getTabListProps(props));
            },
            getTabProps: function getTabProps(props) {
              return getItemProps(_this2.getTabProps(props));
            },
            getTabPanelProps: _this2.getTabPanelProps,
            focusedKey: focusedKey,
            selectedKey: selectedKey
          });
        });
      }
    }]);

    return TabsContainer;
  }(react_selection_["ControlledComponent"]);

  _defineProperty(TabsContainer_TabsContainer, "propTypes", {
    /**
     * Whether to handle vertical keyboard navigation
     */
    vertical: external_prop_types_default.a.bool,

    /**
     * The currently focused key
     */
    focusedKey: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),

    /**
     * The currently selected key
     */
    selectedKey: external_prop_types_default.a.oneOfType([external_prop_types_default.a.number, external_prop_types_default.a.string]),

    /**
     * @param {Object} newState - The updated state
     * @param {Any} newState.selectedKey - The newly selected key
     * @param {Any} newState.focusedKey - The newly focused key
     */
    onStateChange: external_prop_types_default.a.func,

    /**
     * Callback for when a tab has been selected by keyboard or mouse
     * @param {String} selectedKey - The key of the selected tab
     */
    onChange: external_prop_types_default.a.func,

    /**
     * @param {Object} renderProps
     * @param {Function} renderProps.getTabListProps - Props to be spread onto tab list element
     * @param {Function} renderProps.getTabProps - Props to be spread onto each tab element. `({key})` is required. Use `index` attribute for custom ordering.
     * @param {Function} renderProps.getTabPanelProps - Props to be spread onto each tab panel element. `({key})` is required.
     * @param {Any} renderProps.focusedKey - Unique key of currently focused tab
     * @param {Any} renderProps.selectedKey - Unique key of currently selected tab
     */
    children: external_prop_types_default.a.func,

    /**
     * Identical to children
     */
    render: external_prop_types_default.a.func,

    /**
     * The root ID to use for descendants. A unique ID is created if none is provided.
     **/
    id: external_prop_types_default.a.string
  });

  _defineProperty(TabsContainer_TabsContainer, "defaultProps", {
    vertical: false
  }); // EXTERNAL MODULE: external "styled-components"


  var external_styled_components_ = __webpack_require__(4);

  var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_); // EXTERNAL MODULE: external "classnames"


  var external_classnames_ = __webpack_require__(6);

  var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_); // EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-tabs/dist/index.css


  var dist = __webpack_require__(1);

  var dist_default = /*#__PURE__*/__webpack_require__.n(dist); // EXTERNAL MODULE: external "@zendeskgarden/react-theming"


  var react_theming_ = __webpack_require__(3); // CONCATENATED MODULE: ./src/views/TabsView.js


  function TabsView_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var COMPONENT_ID = 'tabs.tabs_view';
  /**
   * Accepts all `<div>` props
   */

  var TabsView = external_styled_components_default.a.div.attrs({
    'data-garden-id': COMPONENT_ID,
    'data-garden-version': "3.3.15",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(dist_default.a['c-tab'], (_classNames = {}, TabsView_defineProperty(_classNames, dist_default.a['c-tab--block'], props.vertical), TabsView_defineProperty(_classNames, dist_default.a['is-rtl'], Object(react_theming_["isRtl"])(props)), _classNames));
    }
  }).withConfig({
    displayName: "TabsView",
    componentId: "r32ypm-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])('tabs.tabs', props);
  });
  TabsView.propTypes = {
    /**
     * Displays vertical TabList styling
     */
    vertical: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var views_TabsView = TabsView; // CONCATENATED MODULE: ./src/views/TabList.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var TabList_COMPONENT_ID = 'tabs.tablist';
  /**
   * Accepts all `<div>` props
   */

  var TabList = external_styled_components_default.a.div.attrs({
    'data-garden-id': TabList_COMPONENT_ID,
    'data-garden-version': "3.3.15",
    className: dist_default.a['c-tab__list']
  }).withConfig({
    displayName: "TabList",
    componentId: "sc-1k06xjs-0"
  })([":focus{outline:none;}", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])('tabs.tab_list', props);
  });
  /** @component */

  /* harmony default export */

  var views_TabList = TabList; // CONCATENATED MODULE: ./src/views/Tab.js

  function Tab_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Tab_COMPONENT_ID = 'tabs.tab';
  /**
   * Accepts all `<div>` props
   */

  var Tab = external_styled_components_default.a.div.attrs({
    'data-garden-id': Tab_COMPONENT_ID,
    'data-garden-version': "3.3.15",
    className: function className(props) {
      var _classNames;

      return external_classnames_default()(dist_default.a['c-tab__list__item'], (_classNames = {}, Tab_defineProperty(_classNames, dist_default.a['is-hovered'], props.hovered), Tab_defineProperty(_classNames, dist_default.a['is-focused'], props.focused), Tab_defineProperty(_classNames, dist_default.a['is-active'], props.active), Tab_defineProperty(_classNames, dist_default.a['is-disabled'], props.disabled), Tab_defineProperty(_classNames, dist_default.a['is-selected'], props.selected), _classNames));
    }
  }).withConfig({
    displayName: "Tab",
    componentId: "g5ynq3-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])('tabs.tab', props);
  });
  Tab.propTypes = {
    hovered: external_prop_types_default.a.bool,
    focused: external_prop_types_default.a.bool,
    active: external_prop_types_default.a.bool,
    disabled: external_prop_types_default.a.bool,
    selected: external_prop_types_default.a.bool
  };
  /** @component */

  /* harmony default export */

  var views_Tab = Tab; // CONCATENATED MODULE: ./src/elements/Tabs.js

  function Tabs_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      Tabs_typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      Tabs_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return Tabs_typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function Tabs_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        Tabs_defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function Tabs_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Tabs_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Tabs_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function Tabs_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function Tabs_defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function Tabs_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) Tabs_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) Tabs_defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function Tabs_possibleConstructorReturn(self, call) {
    if (call && (Tabs_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return Tabs_assertThisInitialized(self);
  }

  function Tabs_assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function Tabs_getPrototypeOf(o) {
    Tabs_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Tabs_getPrototypeOf(o);
  }

  function Tabs_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Tabs_setPrototypeOf(subClass, superClass);
  }

  function Tabs_setPrototypeOf(o, p) {
    Tabs_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return Tabs_setPrototypeOf(o, p);
  }

  function Tabs_defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /**
   * High-level abstraction for basic Tabs implementations.
   */


  var Tabs_Tabs = /*#__PURE__*/function (_ControlledComponent) {
    Tabs_inherits(Tabs, _ControlledComponent);

    function Tabs() {
      var _getPrototypeOf2;

      var _this;

      Tabs_classCallCheck(this, Tabs);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = Tabs_possibleConstructorReturn(this, (_getPrototypeOf2 = Tabs_getPrototypeOf(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.state = {
        selectedKey: undefined,
        focusedKey: undefined
      };
      _this.firstKey = undefined;
      return _this;
    }

    Tabs_createClass(Tabs, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        /**
         * In an uncontrolled state we want to always display the first tab
         */
        if (!this.isControlledProp('selectedKey') && typeof this.firstKey !== 'undefined') {
          this.setControlledState({
            selectedKey: this.firstKey
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            vertical = _this$props.vertical,
            children = _this$props.children,
            onChange = _this$props.onChange,
            otherProps = Tabs_objectWithoutProperties(_this$props, ["vertical", "children", "onChange"]);

        var _this$getControlledSt = this.getControlledState(),
            focusedKey = _this$getControlledSt.focusedKey,
            selectedKey = _this$getControlledSt.selectedKey;

        return external_react_default.a.createElement(TabsContainer_TabsContainer, {
          vertical: vertical,
          selectedKey: selectedKey,
          focusedKey: focusedKey,
          onChange: onChange,
          onStateChange: this.setControlledState
        }, function (_ref) {
          var getTabListProps = _ref.getTabListProps,
              getTabPanelProps = _ref.getTabPanelProps,
              getTabProps = _ref.getTabProps;
          return external_react_default.a.createElement(views_TabsView, _extends({
            vertical: vertical
          }, otherProps), external_react_default.a.createElement(views_TabList, getTabListProps(), external_react_["Children"].map(children, function (child) {
            if (!Object(external_react_["isValidElement"])(child)) {
              return child;
            }

            var _child$props = child.props,
                label = _child$props.label,
                disabled = _child$props.disabled,
                tabProps = _child$props.tabProps;
            var key = child.key;

            if (disabled) {
              return external_react_default.a.createElement(views_Tab, {
                disabled: true
              }, label);
            }

            if (typeof _this2.firstKey === 'undefined') {
              _this2.firstKey = key;
            }

            return external_react_default.a.createElement(views_Tab, getTabProps(Tabs_objectSpread({
              key: key,
              selected: key === selectedKey,
              focused: key === focusedKey
            }, tabProps)), label);
          })), external_react_["Children"].map(children, function (child) {
            if (!Object(external_react_["isValidElement"])(child)) {
              return child;
            }

            if (child.props.disabled) {
              return null;
            } // Don't want to duplicate tabProps in the TabPanel


            var _child$props2 = child.props,
                tabProps = _child$props2.tabProps,
                other = Tabs_objectWithoutProperties(_child$props2, ["tabProps"]); // eslint-disable-line no-unused-vars

            return Object(external_react_["cloneElement"])(child, getTabPanelProps(Tabs_objectSpread({
              key: child.key
            }, other)));
          }));
        });
      }
    }]);
    return Tabs;
  }(react_selection_["ControlledComponent"]);

  Tabs_defineProperty(Tabs_Tabs, "propTypes", {
    children: external_prop_types_default.a.any,

    /**
     * Toggles vertical selection mode of Tabs
     */
    vertical: external_prop_types_default.a.bool,

    /**
     * Currently selected tab to display
     */
    selectedKey: external_prop_types_default.a.any,

    /**
     * @param {Object} newState
     * @param {Any} newState.selectedKey - The newly selected key
     */
    onStateChange: external_prop_types_default.a.func,

    /**
     * Callback for when a tab has been selected by keyboard or mouse
     * @param {String} selectedKey - The key of the selected tab
     */
    onChange: external_prop_types_default.a.func
  });
  Tabs_defineProperty(Tabs_Tabs, "defaultProps", {
    vertical: false
  }); // CONCATENATED MODULE: ./src/views/TabPanel.js

  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  var TabPanel_COMPONENT_ID = 'tabs.tabpanel';
  /**
   * Accepts all `<div>` props
   */

  var TabPanel = external_styled_components_default.a.div.attrs({
    'data-garden-id': TabPanel_COMPONENT_ID,
    'data-garden-version': "3.3.15",
    className: dist_default.a['c-tab__panel']
  }).withConfig({
    displayName: "TabPanel",
    componentId: "sc-1iq1g5b-0"
  })(["", ";"], function (props) {
    return Object(react_theming_["retrieveTheme"])('tabs.tab_panel', props);
  });
  /** @component */

  /* harmony default export */

  var views_TabPanel = TabPanel; // CONCATENATED MODULE: ./src/index.js

  /* concated harmony reexport Tabs */

  __webpack_require__.d(__webpack_exports__, "Tabs", function () {
    return Tabs_Tabs;
  });
  /* concated harmony reexport TabsContainer */


  __webpack_require__.d(__webpack_exports__, "TabsContainer", function () {
    return TabsContainer_TabsContainer;
  });
  /* concated harmony reexport Tab */


  __webpack_require__.d(__webpack_exports__, "Tab", function () {
    return views_Tab;
  });
  /* concated harmony reexport TabList */


  __webpack_require__.d(__webpack_exports__, "TabList", function () {
    return views_TabList;
  });
  /* concated harmony reexport TabPanel */


  __webpack_require__.d(__webpack_exports__, "TabPanel", function () {
    return views_TabPanel;
  });
  /* concated harmony reexport TabsView */


  __webpack_require__.d(__webpack_exports__, "TabsView", function () {
    return views_TabsView;
  });
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /***/

}
/******/
]));